{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "Maximum {size} in size. Only {imageLimit}, {typeLimitText}, {typeLimitZip} or {typeLimitSpreadsheet} allowed. To upload multiple docs, zip first then upload.",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "Maximum {size} in size per file. Maximum {count} files. Only {image}, {text}, {zip} or {spreadsheet} allowed.",
    "oneImage": "ONE image",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "Upload document",
    "uploadDocuments": "Upload documents"
  }
}
